module.exports = __webpack_public_path__ + "img/HD6500.34314977.png";